module.exports = __webpack_public_path__ + "media/site_templates/www.heatingservices.com.au/images/testimonials-9b5bbdd9b26294ae7005274b324637f9.jpg";